module.exports = __webpack_public_path__ + "7d9f6da9aeaa67fb7b8fe51e93dc34de.gif";